import { Component, OnInit } from '@angular/core';
import { MyReportService } from './my-report.service';
import { SessionStorage } from 'ngx-webstorage';
import { EmployeeProject } from './my-report';
import { IMyOptions, IMyDateModel } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-my-report',
  templateUrl: './my-report.component.html',
  styleUrls: ['./my-report.component.css']
})
export class MyReportComponent implements OnInit {
  public myDatePickerOptions: IMyOptions;
  public myDatePickerEndOptions: IMyOptions;
  public startDate: any = '';
  public endDate: any = '';
  public startDatePicker: any = '';
  public endDatePicker: any = '';
  @SessionStorage() public user;
  projectReport = [];

  constructor(
    public reportService: MyReportService,
    private datePipe: DatePipe,
    private snackBar: MatSnackBar) {
    const date: Date = new Date();
    date.setDate(date.getDate() + 1);

    this.myDatePickerOptions = {
      dateFormat: 'dd-mm-yyyy',
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      }
    };

    this.myDatePickerEndOptions = {
      dateFormat: 'dd-mm-yyyy',
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      inline: false,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      }
    };
  }

  ngOnInit() {
    this.getReport();
  }

  /**function to get report */
  getReport() {
    this.reportService.getRMReport(this.user.Empno, this.startDate, this.endDate).subscribe(
      (data) => {
        if (data.payload.length > 0) {
          data.payload.forEach(value => {
            this.projectReport.push(new EmployeeProject(value));
          });
        }
      });
  }

  /**function to select date*/
  utilizationDatePicker() {
    const startDate = this.startDatePicker ? this.datePipe.transform(this.startDatePicker.jsdate, 'yyyy-MM-dd') : '';
    const endDate = this.endDatePicker ? this.datePipe.transform(this.endDatePicker.jsdate, 'yyyy-MM-dd') : '';
    if (startDate && endDate) {
      if (this.startDatePicker.epoc < this.endDatePicker.epoc) {
        this.startDate = startDate;
        this.endDate = endDate;
        this.projectReport = [];
        this.getReport();
      } else {
        this.snackBar.open('Please select the valid date range', 'OK', {
          duration: 3000
        });
      }
    } else if (!startDate && !endDate) {
      this.startDate = '';
      this.endDate = '';
      this.projectReport = [];
      this.getReport();
    } else if (!endDate) {
      this.snackBar.open('Please select the end date', 'OK', {
        duration: 3000
      });
    } else if (!startDate) {
      this.snackBar.open('Please select the start date', 'OK', {
        duration: 3000
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/my-report/my-report.component.ts